import { useTranslation } from 'react-i18next';

import InputErrorIcon from '@crm/shared/assets/icons/input-error.svg?react';
import { cn } from '@crm/shared/lib/styles/utils';
import { InputGroupAddon, SvgIcon } from '@crm/shared/ui';

import { ErrorTooltip } from './ErrorTooltip';

export const InputError = ({
    tooltipId,
    errorMessage,
    className,
    iconClassName,
    tooltipSide,
    tooltipClassName,
    forceTooltipVisible,
}: {
    tooltipId?: string;
    errorMessage: string | undefined;
    className?: string;
    iconClassName?: string;
    tooltipSide?: 'top' | 'bottom';
    tooltipClassName?: string;
    forceTooltipVisible?: boolean;
}) => {
    const { t } = useTranslation();

    return (
        <InputGroupAddon align="inline-end" className={cn('relative', className)}>
            <SvgIcon icon={InputErrorIcon} className={iconClassName} />
            <ErrorTooltip
                id={tooltipId}
                errorMessage={errorMessage ?? t('crm.common.validation.defaultError')}
                side={tooltipSide}
                forceVisible={forceTooltipVisible}
                className={tooltipClassName}
            />
        </InputGroupAddon>
    );
};
